module.exports = __webpack_public_path__ + "img/gongshu.06a3de27.png";